import JSZip from 'jszip';
import { InvalidFileNameError } from './exceptions/invalidFileNameError';
import { FileNotFoundInZipError } from './exceptions/fileNotFoundInZipError';
import mimeTypes from 'mime-types';

export class AutoExecInstance {
  jsZip;
  zipFile;

  constructor() {
    this.jsZip = new JSZip();
    this.zipFile = null;
  }

  async loadZipFile(file, htmlFileName) {
    if (!htmlFileName || !htmlFileName.endsWith('.html')) {
      throw new InvalidFileNameError('File name must be a valid html file');
    }

    this.zipFile = await this.jsZip.loadAsync(file);
    this.htmlFile = this.getEntries().find(([key, value]) => key.includes(htmlFileName));

    if (!this.htmlFile) {
      throw new FileNotFoundInZipError('No html file found');
    }

    return this.zipFile;
  }

  getEntries() {
    return Object.entries(this.zipFile.files);
  }

  async getFileFromEntry(zipEntry, fileName) {
    // Deberá asignar name, lastModifiedDate y type
    const file = await zipEntry.async('blob');
    file.name = fileName;
    file.lastModifiedDate = new Date();
    // No podemos asignar file.type porque no es un atributo de Blob con getter, así que lo hacemos de otra manera
    Object.defineProperty(file, 'type', {
      get: () => mimeTypes.lookup(fileName)
    });
    return file;
  }

  getTitleByFileName(fileName) {
    return fileName.split('/').pop();
  }
}
